import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import moment from 'moment';
import { createAxiosInstance } from "../utils/AxiosInstance";
import { useConfig } from "../utils/ConfigContext";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";

import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/plugins/monthSelect/style.css";

const CenterCampaignExpenseReport = () => {
    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

   

    return (
        <div className="card shadow-sm">
            <div className="card-body">
                <div className="mt-10">
                    <table className="table table-sm table-bordered table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th className="text-center">Center Name</th>
                                <th className="text-center" >Budget (Expese)</th>
                                <th className="text-center" >OPD</th>
                                <th className="text-center" >Conversion</th>
                                <th className="text-center" >Last Day Patients</th>
                                <th className="text-center" >Total Patients</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center" colSpan={6}>No Data found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default CenterCampaignExpenseReport;